import * as React from 'react';
import { Prompt, RouteComponentProps, withRouter } from 'react-router';

export interface LeaveRouteDirtyWrapperProps extends RouteComponentProps {
  blockChange: boolean;
}

class LeaveRouteDirtyWrapper extends React.Component<LeaveRouteDirtyWrapperProps> {
  render() {
    return <Prompt when={this.props.blockChange} message={(location) => 'If you change page you will loose change!'} />;
  }
}

export default withRouter(LeaveRouteDirtyWrapper);
